import React from 'react';

import Image from '../../../../library/image/image';

import { ProductTypeEnum } from '../../../../shared/types/graphql-types';

import styles from './promotion-brand-logo.scss';

interface PromotionBrandLogoProps {
  brand: string;
  productType: string;
}

function PromotionBrandLogo(props: PromotionBrandLogoProps) {
  const { brand, productType } = props;

  let brandName;
  brandName = brand.replace(/\s(tires?|wheels?)$/i, '').replace(' ', '-');

  let productTypeHash;
  if (productType === ProductTypeEnum.Tires) {
    productTypeHash = 'tire';
  } else if (productType === ProductTypeEnum.Wheels) {
    productTypeHash = 'wheel';
  } else {
    productTypeHash = 'accessory';
  }

  return (
    <div className={styles['container']}>
      <Image
        alt={`${brand} Logo`}
        aria-label={`${brand} Logo`}
        className={styles['brand-logo']}
        src={
          'https://discounttire.scene7.com/is/image/discounttire/BRANDlogo_' +
          brandName.toLowerCase() +
          '_' +
          productTypeHash +
          '-2000'
        }
      />
    </div>
  );
}

export default PromotionBrandLogo;
